'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInUserLinks = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedInUserLinks = exports.LoggedInUserLinks = function (_PureComponent) {
  (0, _inherits3.default)(LoggedInUserLinks, _PureComponent);

  function LoggedInUserLinks() {
    (0, _classCallCheck3.default)(this, LoggedInUserLinks);
    return (0, _possibleConstructorReturn3.default)(this, (LoggedInUserLinks.__proto__ || (0, _getPrototypeOf2.default)(LoggedInUserLinks)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoggedInUserLinks, [{
    key: 'handleLogoutClick',

    /* istanbul ignore next */
    value: function handleLogoutClick(event) {
      event.preventDefault();
      var form = document.createElement('form');
      form.action = '/logout';
      form.method = 'POST';
      document.body.appendChild(form);
      form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      var canViewUnifiedSearch = this.props.canViewUnifiedSearch;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        canViewUnifiedSearch && _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/search' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'header.link.search',
              defaultMessage: 'Find a class'
            })
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: '/settings/membership' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'accountDropdown.accountLink',
              defaultMessage: 'Settings'
            })
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: '/logout', onClick: this.handleLogoutClick },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'accountDropdown.logoutLink',
              defaultMessage: 'Log out'
            })
          )
        )
      );
    }
  }]);
  return LoggedInUserLinks;
}(_react.PureComponent);

LoggedInUserLinks.propTypes = {
  canViewUnifiedSearch: _propTypes2.default.bool
};